<template>
  <div class="contact-data split-view fill-height">
    <v-row class="split-view__row fill-height" no-gutters>
      <left-side-image/>
      <v-col cols="12" md="7" class="split-view__panel">
        <div class="split-view__scroll">
          <nav-bar-page/>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import LeftSideImage from "@/components/Layouts/LeftSideImage";
import NavBarPage from "@/components/Layouts/NavBarPage";
import {api} from "@/helpers/axios";
import {locals} from "@/helpers/locals";

export default {
  name: 'DevPage',
  components: {LeftSideImage, NavBarPage},
  data() {
    return {
      newData: null
    }
  },
  created() {

    const currentDate = new Date();

    const day = currentDate.getDate().toString().padStart(2, "0");
    const month = (currentDate.getMonth() + 1).toString().padStart(2, "0");
    const year = currentDate.getFullYear();

    const formatedDate = `${day}-${month}-${year}`;

    api.post('https://vardiseguros.bio.credit/calcularcuota', {
      data: {
        fecha: formatedDate,
        valor: 2000000,
        plazo: 12,
        tasa: 27.13,
        portafolio_id: 10040,
        idvardi: 309
      }
    })
    .then(response => {

      console.log('calculo sigma', response, response.data.plan_pagos[0].cuota);

    }).catch(function (error) {
      //
      console.log('errors: ', error);

      try {
        let status = error.response.status;
        if(status == 401){
          locals.clearLocal();
          this.$router.push('/');
        }
        let errors = error.response.data.errors;
        let message = '';
        for (var [key, value] of Object.entries(errors)) {
          console.log(key + ' : ' + value);
          message = message + value + '<br>';
        }
        this.snackbarMessage = message;
        this.snackbar = true;
        this.loading = false;
      } catch (e) {
        console.log(e);
      }

    }.bind(this))
  },
  mounted() {
  },
  methods: {

  }
}
</script>

<style scoped lang="scss">


</style>
